import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarServicioConfiguracion } from '../../../actions/configuracion';

const EliminarServicio = ({ servicio, reestablecerServicio }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar servicio */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarServicioConfiguracion(servicio?._id));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerServicio(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(servicio){
            setEliminarModal(true);
        }
    }, [servicio]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar servicio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    ¿Deseas eliminar a 
                    {' ' + servicio?.nombre}
                    {' con ' + (servicio?.locatarios == 1 ? servicio?.locatarios + ' locatario relacionado' : servicio?.locatarios + ' locatarios relacionados')}
                    ?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarServicio;